import moment from 'moment';

import dateFormat from 'config/dateFormat';

const getCurrentDate = ({ value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  return moment().format(dateFormat);
};

export default getCurrentDate;



// WEBPACK FOOTER //
// ./src/utils/print/getCurrentDate.js